// extracted by mini-css-extract-plugin
module.exports = {"header":"header__1-nOb","content":"content__1eNsI","right":"right__2DwAO","link":"link__2KOlh","login":"login__3PlQc","logo":"logo__mgfBw"};